"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPEFORM_DOMAIN = exports.COOKIE_PATH = void 0;
exports.deleteAllNonStrictlyNecessaryCookies = deleteAllNonStrictlyNecessaryCookies;
exports.deleteAttributionUserIdCookie = deleteAttributionUserIdCookie;
exports.deleteNonStrictlyNecessaryCookies = deleteNonStrictlyNecessaryCookies;
exports.deleteRudderstackAnonymousIdCookie = deleteRudderstackAnonymousIdCookie;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("./constants");
var TYPEFORM_DOMAIN = exports.TYPEFORM_DOMAIN = '.typeform.com';
var COOKIE_PATH = exports.COOKIE_PATH = '/';

// Renderer
var RENDERER_STRICTLY_NECESSARY_COOKIES = ['__cf_bm', '_dd_s', 'AWSALBTG', 'AWSALBTGCORS', 'dd_cookie_test_', 'tf_respondent_cc'];

// Admin & Web
var TYPEFORM_STRICTLY_NECESSARY_COOKIES = ['__cf_bm', '__cfduid', '__cfruid', '__stripe_mid', '__stripe_sid', '_help_center_session', '_zendesk_authenticated', '_zendesk_session', '_zendesk_shared_session', '_zendesk_thirdparty_test', 'account_ids', 'AWSALBTG', 'AWSALBTGCORS', 'cf_chl_2', 'cf_chl_cc_xxxxxxxxxxxxxxxxxxxxx', 'cf_chl_prog', 'cf_chl_seq_xxxxxxxxxxxxxxxxxxxxx', 'cf_use_ob', 'device_view', 'experiments-fingerprint', 'first_interaction', 'JSESSIONID', 'just_logged_in', 'lightstep_guid%2FsharedViewOrApp', 'lightstep_session_id', 'm', 'mv', 'OptanonAlertBoxClosed', 'OptanonConsent', 'PHPSESSID', 'Session', 'signup_user_agent', 'targetPathRedirect', 'tf_auth', 'tf_email', 'user_plan', 'ajs_anonymous_id'];
var STRICTLY_NECESSARY_COOKIES = [].concat(TYPEFORM_STRICTLY_NECESSARY_COOKIES, RENDERER_STRICTLY_NECESSARY_COOKIES);
var STRICTLY_NECESSARY_AND_PERSISTING_COOKIES = [].concat((0, _toConsumableArray2["default"])(STRICTLY_NECESSARY_COOKIES), [
/* While these cookies are not strictly necessary, these are cookies
 we want to persist unless the user specifically rejects analytical cookies */
_constants.ATTRIBUTION_COOKIE_NAME, _constants.RUDDERSTACK_ANONYMOUS_ID_COOKIE_NAME]);
function deleteCookie(cookie) {
  _jsCookie["default"].remove(cookie, {
    path: COOKIE_PATH,
    domain: TYPEFORM_DOMAIN
  });
}
function deleteAttributionUserIdCookie() {
  deleteCookie(_constants.ATTRIBUTION_COOKIE_NAME);
}
function deleteRudderstackAnonymousIdCookie() {
  deleteCookie(_constants.RUDDERSTACK_ANONYMOUS_ID_COOKIE_NAME);
}
function deleteNonStrictlyNecessaryCookies() {
  var allCookies = Object.keys(_jsCookie["default"].get());
  var nonNecessaryCookies = allCookies.filter(function (cookie) {
    return !STRICTLY_NECESSARY_AND_PERSISTING_COOKIES.includes(cookie);
  });
  nonNecessaryCookies.forEach(deleteCookie);
}
function deleteAllNonStrictlyNecessaryCookies() {
  var allCookies = Object.keys(_jsCookie["default"].get());
  var nonNecessaryCookies = allCookies.filter(function (cookie) {
    return !STRICTLY_NECESSARY_COOKIES.includes(cookie);
  });
  nonNecessaryCookies.forEach(deleteCookie);
}